<template>
    <div>
        <v-overlay :value="preview" color="white" opacity="0.9" z-index="9999">
            <div style="display:flex; flex-direction:column; text-align:center; color:black">
                <v-icon @click="preview=false" color="black" class="ml-auto">mdi-close</v-icon>
                <h3 v-if="popup.heading">{{popup.heading}}</h3>
                <img
                    :width="$vuetify.breakpoint.xs ? '300rem' : '500rem'"
                    v-if="popup.imageUrl"
                    :src="popup.imageUrl"
                />
                <p v-if="popup.body">{{popup.body}}</p>
            </div>
        </v-overlay>
        <button class="btn btn-outline-warning" @click="toggleMaint()">
            {{maint ? 'Disable' : 'Enable'}} Maintenance Pop-up
        </button>
        <br />
        <br />
        <button class="btn btn-outline-dark" @click="show = !show">Manage Pop-up</button>
        <div v-if="show">
            <div>
                <button
                    class="btn mt-3 btn-sm"
                    :class="[popup.enabled ? 'btn-outline-warning' : 'btn-outline-success']"
                    @click="changeEnabled()"
                >{{ popup.enabled ? 'Disable' : 'Enable'}} Pop-up</button>
                <br />
                <button
                    class="btn btn-sm mt-3 btn-outline-primary"
                    @click="preview = !preview"
                >Preview Pop-up</button>
            </div>
            <div class="mt-5">
                <v-text-field v-model="heading" label="Heading"></v-text-field>
                <v-textarea auto-grow outlined v-model="body" label="Body"></v-textarea>
                <v-file-input
                    class="mt-n3"
                    accept="image/*"
                    prepend-icon="mdi-paperclip"
                    v-model="image"
                    label="Image"
                ></v-file-input>
                <div class="mt-n5" style="display:flex;">
                    <v-checkbox v-model="enable"></v-checkbox>
                    <div class="mt-5">Enable</div>
                </div>
                <button
                    class="btn btn-sm btn-outline-info"
                    @click="replace()"
                >Replace Pop-up</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require("../../firebaseConfig");
export default {
    data() {
        return {
            preview: false,
            show: false,
            heading: "",
            body: "",
            image: null,
            enable: false,
        };
    },
    computed: {
        ...mapState(["popup", "maint"])
    },
    methods: {
        replace() {
            if (!(this.image || this.heading || this.body)) {
                this.$emit(
                    "toast",
                    "err",
                    "At least one field should be filled"
                );
                return;
            }
            if (this.image) {
                const ref = fb.storageRef.child(`Resources/${this.image.name}`);
                const upload = ref.put(this.image);
                const vue = this;
                upload.on(
                    "state_changed",
                    function(snapshot) {
                        console.log("Upload in progress");
                    },
                    function(err) {
                        console.error(err);
                    },
                    function() {
                        upload.snapshot.ref
                            .getDownloadURL()
                            .then(function(url) {
                                fb.db
                                    .collection("misc")
                                    .doc("popup")
                                    .set({
                                        enabled: vue.enable,
                                        imageUrl: url,
                                        body: vue.body,
                                        heading: vue.heading
                                    });
                                return url;
                            })
                            .then(url => {
                                vue.popup = {
                                    enabled: vue.enable,
                                    imageUrl: url,
                                    body: vue.body,
                                    heading: vue.heading
                                };
                                vue.$emit(
                                    "toast",
                                    "suc",
                                    "Popup successfully set with image"
                                );
                                vue.enable = false;
                                vue.body = "";
                                vue.heading = "";
                                vue.image = null;
                            });
                    }
                );
            } else {
                fb.db
                    .collection("misc")
                    .doc("popup")
                    .set({
                        enabled: this.enable,
                        body: this.body,
                        heading: this.heading,
                        imageUrl: ""
                    })
                    .then(() => {
                        this.popup = {
                            enabled: this.enable,
                            body: this.body,
                            heading: this.heading,
                            imageUrl: ""
                        };
                        this.$emit("toast", "suc", "Popup successfully set");
                        this.enable = false;
                        this.body = "";
                        this.heading = "";
                        this.image = null;
                    });
            }
        },
        changeEnabled() {
            fb.db
                .collection("misc")
                .doc("popup")
                .set(
                    {
                        enabled: !this.popup.enabled
                    },
                    {
                        merge: true
                    }
                )
                .then(() => {
                    this.popup.enabled = !this.popup.enabled;
                });
        },
        toggleMaint() {
            fb.db
                .collection("misc")
                .doc("maint")
                .update({
                    show: !this.maint
                })
                .then(() => {
                    this.$store.commit("setMaint", !this.maint);
                });
        },
    }
};
</script>